import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Support2.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

const SupportCenter = () => {
  const [activePage, setActivePage] = useState("home");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    position: "",
    company: "",
    companyId: "",
    companyName: "",
    phoneNumber: "",
    address: "",
    password: "",
    confirmPassword: "",
    taxno: "",
    companyManual: "",
    addressManual: "",
  });

  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [allowCompanySelect, setAllowCompanySelect] = useState(false);
  const [showNewCompanyInput, setShowNewCompanyInput] = useState(false);

  const handleEmailSubmit = async () => {
    try {
      if (!validateEmail(formData.email)) {
        alert("Please enter a valid email address.");
        return;
      }

      const response = await axios.post(
        "/otp",
        { email: formData.email.toLowerCase() },
        { headers: { "Content-Type": "application/json" } }
      );

      const { emailExists } = response.data;

      if (emailExists) {
        alert(
          "This email is already registered. Please use a different email."
        );
      } else {
        setIsOtpSent(true);
        alert("OTP has been sent to your email!");
      }
    } catch (err) {
      console.error("Error while sending OTP:", err);
      alert("Failed to send OTP. Please try again later.");
    }
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  };

  const handleSignin = async () => {
    const emailInput = document.getElementById("email");
    const passwordInput = document.getElementById("password");

    if (!emailInput.value.trim() || !passwordInput.value.trim()) {
      alert("Please make sure to provide both your email and password.");
      return;
    }

    try {
      const response = await fetch("/auth/signin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          email: emailInput.value.trim().toLowerCase(),
          password: passwordInput.value.trim(),
        }),
      });

      const text = await response.text();
      const result = (() => {
        try {
          return JSON.parse(text);
        } catch {
          return {};
        }
      })();

      if (response.ok) {
        alert(result.message || "Signed in");

        navigate("/tickets", {
          state: { userId: result.userId, userEmail: result.userEmail },
        });
      } else {
        alert(result.message || "เกิดข้อผิดพลาดในการเข้าสู่ระบบ");
      }
    } catch (error) {
      console.error("Error during sign-in:", error);
      alert("เกิดข้อผิดพลาดในการเข้าสู่ระบบ กรุณาลองอีกครั้ง");
    }
  };

  const handleOtpSubmit = async () => {
    try {
      const response = await axios.post(
        "/otp/verify-otp",
        {
          email: formData.email.toLowerCase(),
          otp,
        }
      );
      if (response.data.success) {
        setActivePage("form");
        setOtpError("");
      } else {
        setOtpError("Incorrect OTP. Please try again.");
      }
    } catch (err) {
      setOtpError("Error verifying OTP. Please try again.");
    }
  };

  const handleInputChange = (e) => {
    const { name, id, value, dataset } = e.target;

    const fieldName = name || id || dataset.even;

    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: fieldName === "email" ? value.toLowerCase() : value,
    }));
  };

  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [timer, setTimer] = useState(180);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const [otpError, setOtpError] = useState("");
  // const addressToSubmit = formData.address || formData.addressManual;
  // const companyToSubmit = formData.companyId || formData.companyManual;

  useEffect(() => {
    let timerInterval;
    if (isOtpSent && timer > 0) {
      timerInterval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsOtpExpired(true);
    }
    return () => clearInterval(timerInterval);
  }, [isOtpSent, timer]);

  useEffect(() => {
    if (formData.password.trim() && formData.confirmPassword.trim()) {
      validatePassword(
        formData.password.trim(),
        formData.confirmPassword.trim()
      );
    }
  }, [formData.password, formData.confirmPassword]);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      validatePassword(
        updatedData.password.trim(),
        updatedData.confirmPassword.trim()
      );
      return updatedData;
    });
  };

  const validatePassword = (password, confirmPassword) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    password = password?.trim() || "";
    confirmPassword = confirmPassword?.trim() || "";

    if (password.length < minLength) {
      setPasswordError("รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร");
      return false;
    }

    if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar) {
      setPasswordError(
        "รหัสผ่านต้องมีตัวพิมพ์ใหญ่, ตัวพิมพ์เล็ก, ตัวเลข และอักขระพิเศษ"
      );
      return false;
    }

    setPasswordError("");

    if (password !== confirmPassword) {
      setConfirmPasswordError("รหัสผ่านไม่ตรงกัน❌");
      return false;
    } else {
      setConfirmPasswordError("");
    }

    return true;
  };

  const isEmpty = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string" && v.trim() === "") return true;
    return false;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const addressToSubmit = formData.address || formData.addressManual;
    const companyToSubmit = formData.companyId || formData.companyManual;

    const requiredFields = {
      fullName: formData.fullName,
      position: formData.position,
      phoneNumber: formData.phoneNumber,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      company: companyToSubmit,
      address: addressToSubmit,
    };

    for (const [fieldName, value] of Object.entries(requiredFields)) {
      if (isEmpty(value)) {
        alert(`กรุณากรอกข้อมูลให้ครบทุกช่อง❌ (พบปัญหาที่ ${fieldName})`);
        return;
      }
    }

    // Validate phone
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phoneNumber)) {
      alert("Please enter a valid phone number (10 digits only)📞");
      return;
    }

    // Validate name
    const nameRegex = /^[A-Za-zก-๙\s]+$/;
    if (!nameRegex.test(formData.fullName.trim())) {
      alert("ชื่อไม่ควรมีตัวเลขหรืออักขระพิเศษ❌");
      return;
    }

    // Validate password
    if (/\s/.test(formData.password)) {
      alert("รหัสผ่านไม่ควรมีช่องว่าง (space) ❌");
      return;
    }

    if (
      !validatePassword(
        formData.password.trim(),
        formData.confirmPassword.trim()
      )
    ) {
      alert(
        "Registration failed: Password does not meet the required conditions ❌"
      );
      return;
    }

    try {
      const response = await fetch("/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email.toLowerCase(),
          name: formData.fullName.trim(),
          position: formData.position.trim(),
          companyId: formData.companyId || null,
          companyManual: formData.companyManual || null,
          taxno: formData.taxno || null,  
          phone: formData.phoneNumber.trim(),
          address: addressToSubmit.trim(),
          timezone: formData.timeZone?.trim() || "",
          password: formData.password.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("Registration successful. ✅");
        setFormData({
          email: "",
          fullName: "",
          position: "",
          companyId: "",
          companyName: "",
          companyManual: "",
          taxno: "",
          phoneNumber: "",
          address: "",
          addressManual: "",
          timeZone: "",
          password: "",
          confirmPassword: "",
        });
        window.location.reload();
      } else {
        alert(data.message || "An error occurred.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
    }
  };

  const [options, setOptions] = useState({
    company: [],
    address: [],
  });

  useEffect(() => {
    const domain = formData.email.split("@")[1];
    if (domain && !/gmail\.com|hotmail\.com/.test(domain)) {
      fetch(`/otp?domain=${domain}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const contentType = response.headers.get("content-type");
          if (!contentType || !contentType.includes("application/json")) {
            throw new Error(
              `Invalid response format: Expected JSON, got ${contentType}`
            );
          }
          return response.json();
        })
        .then((data) => {
          setOptions({
            company: data.companyOptions || [],
            address: data.addressOptions || [],
          });
        })
        .catch((err) =>
          console.error("Error fetching domain data:", err.message)
        );
    }
  }, [formData.email]);
  const [loadingCompany, setLoadingCompany] = useState(false);

  const handleSearchCompany = async () => {
    try {
      if (!formData.taxno || formData.taxno.length < 13) {
        alert("กรุณากรอกเลขทะเบียน 13 ตัว");
        return;
      }

      setLoadingCompany(true);  

      setOptions((prev) => ({ ...prev, company: [] }));
      setFormData((prev) => ({
        ...prev,
        companyId: "",
        companyName: "",
        companyManual: "",
      }));

      const res = await axios.get(
        `/customer-company/search?tax=${formData.taxno}`
      );

      const list = res?.data?.companies || [];

      setAllowCompanySelect(true);

      if (list.length === 0) {
        alert("ไม่พบบริษัทในระบบ กรุณากรอกชื่อบริษัทด้วยตนเอง");
        return;
      }

      setOptions((prev) => ({
        ...prev,
        company: list.map((c) => ({ id: c.id, name: c.name })),
      }));

      if (list.length === 1) {
        setFormData((prev) => ({
          ...prev,
          companyId: list[0].id,
          companyName: list[0].name,
        }));
      }
    } catch (err) {
      console.error("ค้นหาบริษัทผิดพลาด:", err);
    } finally {
      setLoadingCompany(false);  
    }
  };

  return (
    <div className="about-container2">
      <div className="support-navigation">
        <div className="nav-center">
          <button
            className={`support-nav-button ${
              activePage === "home" ? "active" : ""
            }`}
            onClick={() => setActivePage("home")}
          >
            <i className="fas fa-home"></i> Support Center Home
          </button>
        </div>
        <div className="auth-container">
          <p>Guest User</p>
          <p>|</p>
          <button
            className="link-button"
            onClick={() => setActivePage("sign-in")}
          >
            Sign In
          </button>
        </div>
      </div>

      <main className="support-content">
        {activePage === "home" && (
          <div className="support-home">
            <h1>Support Center</h1>
            <h2>Proscope Ticket System (PTS)</h2>
            <div className="support-card">
              <p>Welcome to the Support Center</p>
              <p className="secondary-text">
                In order to streamline support requests and better serve you, we
                utilize a support ticket system. Every support request is
                assigned a unique ticket number which you can use to track the
                progress and responses online. For your reference, we provide
                complete archives and history of all your support requests. A
                valid email address is required to submit a ticket.
              </p>
              <div className="button-container">
                <button
                  className="btn-check-status"
                  onClick={() => setActivePage("register")}
                >
                  Register
                </button>
              </div>
            </div>
          </div>
        )}

        {activePage === "sign-in" && (
          <div className="sign-in-container">
            <h2>Sign in to Proscope Co., Ltd</h2>
            <p>
              To better serve you, we encourage our Clients to register for an
              account.
            </p>
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Password:</label>
              <input
                type="password"
                id="password"
                placeholder="Enter your password"
                value={formData.password || ""}
                onChange={handleInputChange}
              />
            </div>
            <button className="submit-button" onClick={handleSignin}>
              Sign In
            </button>
            <br />
            <br />
            <p>
              If this is your first time contacting us or you've lost the ticket
              number, please or{" "}
              <button
                className="link-button"
                onClick={() => setActivePage("register")}
              >
                register for an account
              </button>{" "}
              I'm an agent{" "}
              <button
                className="link-button"
                onClick={() => window.open("/admin", "_blank")}
              >
                sign in here
              </button>{" "}
              or{" "}
              <button
                className="link-button"
                onClick={() => window.open("/manuals/user-guide.pdf", "_blank")}
              >
                manual
              </button>
              <br /> Did you{" "}
              <button
                className="link-button"
                onClick={() => navigate("/resetpass")}
              >
                forget your password?
              </button>
            </p>
          </div>
        )}

        {activePage === "register" && (
          <div className="register-container">
            <p>Please enter your email to receive an OTP.</p>
            <div className="input-group">
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                className="input-field"
                disabled={isOtpSent && !isOtpExpired}
              />
            </div>

            {(!isOtpSent || isOtpExpired) && (
              <button className="submit-button" onClick={handleEmailSubmit}>
                {isOtpExpired ? "Resend OTP" : "Send OTP"}
              </button>
            )}

            {isOtpSent && !isOtpExpired && (
              <p className="timer-text">
                Please wait until the OTP expires before requesting a new one.
              </p>
            )}
          </div>
        )}

        {isOtpSent && activePage === "register" && (
          <div className="otp-container">
            <p>Enter the OTP sent to your email.</p>
            {isOtpExpired ? (
              <p className="error-message">
                The OTP has expired. Please refresh and request a new OTP.
              </p>
            ) : (
              <p className="timer-text">{`Time left: ${timer}s`}</p>
            )}

            <div className="input-group">
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className="input-field"
              />
            </div>

            {otpError && <p className="error-message">{otpError}</p>}

            <button
              className="submit-button"
              onClick={handleOtpSubmit}
              disabled={isOtpExpired}
            >
              Verify OTP
            </button>
          </div>
        )}

        {activePage === "form" && (
          <div className="form-container">
            <p>Please fill in your details to complete registration.</p>

            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                value={formData.email}
                readOnly
                className="input-field"
              />
            </div>

            <div className="form-group">
              <label>Full Name:</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                className="input-field"
              />
            </div>

            <div className="form-group">
              <label>Position:</label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleInputChange}
                placeholder="Enter your Position"
                className="input-field"
              />
            </div>
            <div className="form-group">
              <label>Tax ID / เลขทะเบียนบริษัท (13 หลัก):</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  name="taxno"
                  value={formData.taxno || ""}
                  maxLength={13}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, taxno: e.target.value }))
                  }
                  placeholder="เช่น 1234567890123"
                  className="input-field"
                  style={{ flex: 1 }}
                />

                <button
                  type="button"
                  className="submit-button"
                  onClick={handleSearchCompany}
                  disabled={loadingCompany}
                  style={{
                    whiteSpace: "nowrap",
                    opacity: loadingCompany ? 0.6 : 1,
                  }}
                >
                  ค้นหา
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>Company:</label>

              <div className="company-container">
                <select
                  className="input-field"
                  disabled={!allowCompanySelect}
                  value={
                    formData.companyId || (showNewCompanyInput ? "new" : "")
                  }
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "new") {
                      setShowNewCompanyInput(true);
                      setFormData((prev) => ({
                        ...prev,
                        companyId: "",
                        companyName: "",
                        companyManual: "",
                      }));
                    } else {
                      setShowNewCompanyInput(false);
                      const selected = options.company.find(
                        (item) => item.id === Number(value)
                      );

                      setFormData((prev) => ({
                        ...prev,
                        companyId: selected?.id || "",
                        companyName: selected?.name || "",
                        companyManual: "",
                      }));
                    }
                  }}
                >
                  <option value="">Select company</option>

                  {options.company.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.name}
                    </option>
                  ))}

                  <option value="new">+ Add new</option>
                </select>

                {showNewCompanyInput && (
                  <input
                    type="text"
                    name="companyManual"
                    value={formData.companyManual}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        companyManual: e.target.value,
                      }))
                    }
                    placeholder="Enter new company name"
                    className="input-field mt-8"
                  />
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Phone Number:</label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
                className="input-field"
              />
            </div>
            <div className="form-group">
              <label>Address:</label>

              {options.address.length > 0 ? (
                <>
                  <input
                    type="text"
                    name="addressManual"
                    value={formData.addressManual || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        addressManual: e.target.value,
                        address: "",
                      }))
                    }
                    placeholder="Enter your address manually"
                    className="input-field"
                  />

                  <div className="or-divider">
                    <span className="or-text">หรือ</span>
                  </div>

                  <select
                    name="address"
                    value={formData.address}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        address: e.target.value,
                        addressManual: "",
                      }))
                    }
                    className="input-field"
                  >
                    <option value="">Select your address</option>
                    {options.address.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </>
              ) : (
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="Enter your address"
                  className="input-field"
                />
              )}
            </div>

            <div className="form-group">
              <label>Time Zone:</label>
              <select
                name="timeZone"
                value={formData.timeZone}
                onChange={handleInputChange}
                className="input-field"
              >
                <option value="">Select Time Zone</option>
                <option value="utc-5">UTC-5</option>
                <option value="utc+1">UTC+1</option>
                <option value="utc+7">UTC+7</option>
              </select>
            </div>

            <div className="form-group">
              <label>Password:</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handlePasswordChange}
                placeholder="Enter your password"
              />
              {passwordError && (
                <span className="error-message">{passwordError}</span>
              )}
            </div>

            <div className="form-group">
              <label>Confirm Password:</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handlePasswordChange}
                placeholder="Confirm your password"
              />
              {confirmPasswordError && (
                <span className="error-message">{confirmPasswordError}</span>
              )}
            </div>

            <button className="submit-button" onClick={handleFormSubmit}>
              Register
            </button>
          </div>
        )}

        {activePage === "agent-sign-in" && (
          <div className="sign-in-container">
            <h2>Admin and Agent Panels</h2>
            <p>Please sign in to access the admin and agent panels.</p>
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                id="email2"
                placeholder="Enter your email"
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>Password:</label>
              <input
                type="password"
                id="password2"
                placeholder="Enter your password"
                value={formData.password || ""}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
            </div>
            <button
              className="submit-button"
              onClick={() => window.open("/support/agent", "_blank")}
            >
              {" "}
              Sign In
            </button>
          </div>
        )}
      </main>
    </div>
  );
};

export default SupportCenter;
